//PATH
export const SEARCH_PATH = "/search";
export const PROFILE_PATH = "/profile";
export const DASHBOARD_PATH = "/dashboard";
export const SUPPORT_PATH = "/support";
export const DOC_PATH = "/doc";
export const GENERAL_PATH = "/general";
export const APPLICATIONS_PATH = "/applications";
export const APPLICATION_PATH = "/application";
export const LOGIN_PATH = "/login";
export const LOGOUT_PATH = "/logout";
export const LEARN_PATH = "/learn";
export const PRICING_PATH = "/pricing";
export const HOME_PATH = "/home";
export const WEB_PATH = "/web";
export const CSHARP_PATH = "/csharp";
export const NODE_PATH = "/node";
export const IOS_PATH = "/ios";
export const ANDROID_PATH = "/android";
export const APIS_PATH = "/apis";
export const STORE_PATH = "/store";
export const BILLING_PATH = "/billing";
export const SANDBOX_PATH = "/sandbox";
export const REACTNATIVE_PATH = "/reactnative";
export const ROOT_PATH = "/";
export const CREATE_PATH = "/create";
export const EDIT_PATH = "/edit";
export const STATISTICS_PATH = "/statistics";
export const SSO_PATH = "/sso"

export const ErrorMessageDisplayTimeout = 3000;
export const MinProgressTimeout = 200;
